import { render, staticRenderFns } from "./Pub.vue?vue&type=template&id=4fe6bd2a"
import script from "./Pub.vue?vue&type=script&lang=js"
export * from "./Pub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports